export const ENV_CONFIG = {
  APP_VERSION: __APP_VERSION__,
  ENV: __ENV__,
  IS_DEV: __ENV__ === 'local' || __ENV__ === 'development' || __ENV__ === 'dev',
  IS_PROD: __ENV__ === 'production',
  SHOW_CUSTOMER_OPTIONS: __SHOW_CUSTOMER_OPTIONS__ === 'true',
  IS_CUSTOMER_OPTIONS_REQUIRED: __IS_CUSTOMER_OPTIONS_REQUIRED__ === 'true',
  /** Matches deployment profile `:uat` in `global/env.edn`. */
  IS_UAT: __ENV__ === 'uat',
  /** Weekly plan factory GPS row: UAT deploys + local/dev builds. */
  SHOW_WEEKLY_PLAN_FACTORY_COORDINATES:
    __ENV__ === 'uat' || __ENV__ === 'local' || __ENV__ === 'development' || __ENV__ === 'dev',
} as const;
